"use client";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";

// src/components/sections/FeaturesBlock/FeaturesBlock.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function FeaturesBlock({
  referId,
  title,
  cards,
  className,
  border
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      id: referId,
      className: `flex justify-center py-40 lg:py-80 px-24 mx-auto ${className}`,
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: `flex flex-col lg:flex-row gap-16 md:gap-24 lg:gap-40 justify-center items-center p-24 lg:p-40 max-w-[455px] md:max-w-7xl bg-display-100 ${border ? border : "rounded-2xl md:rounded-tr-none"}`,
          children: [
            /* @__PURE__ */ jsxs("div", { className: "flex flex-col lg:flex-row gap-16 md:gap-24 lg:gap-40 items-center", children: [
              /* @__PURE__ */ jsx(
                "h2",
                {
                  dangerouslySetInnerHTML: {
                    __html: title
                  },
                  className: "lg:max-w-[258px] font-display text-3xl lg:text-4xl font-bold leading-7 lg:leading-8 text-center lg:text-left"
                }
              ),
              /* @__PURE__ */ jsx(
                Icon_default,
                {
                  name: "chevronDown",
                  className: "lg:hidden min-w-[40px] min-h-[40px] text-stone-500 fill-current"
                }
              ),
              /* @__PURE__ */ jsx(
                Icon_default,
                {
                  name: "chevronRight",
                  className: "hidden lg:block min-w-[40px] min-h-[40px] text-stone-500 fill-current"
                }
              )
            ] }),
            /* @__PURE__ */ jsx("div", { className: "grid md:flex flex-col md:flex-row md:flex-wrap lg:flex-nowrap grid-cols-2 gap-24 md:gap-40 md:mx-auto", children: cards.map(({ title: title2, description, stonjiName }) => /* @__PURE__ */ jsxs(
              "div",
              {
                className: "flex flex-col flex-1 gap-16 lg:max-w-[192px]",
                children: [
                  /* @__PURE__ */ jsx(
                    Icon_default,
                    {
                      name: stonjiName,
                      className: "w-[64px] lg:w-[80px] h-[64px] lg:h-[80px]"
                    }
                  ),
                  title2 && /* @__PURE__ */ jsx(
                    "p",
                    {
                      className: "font-bold text-base md:text-lg md:leading-4",
                      dangerouslySetInnerHTML: {
                        __html: title2
                      }
                    }
                  ),
                  description && /* @__PURE__ */ jsx(
                    "p",
                    {
                      className: "text-base",
                      dangerouslySetInnerHTML: {
                        __html: description
                      }
                    }
                  )
                ]
              },
              `feature-${title2}`
            )) })
          ]
        }
      )
    }
  );
}

export {
  FeaturesBlock
};
